<div class="side-bar-container" [class.expanded]="expanded()">
  <div class="toggle-container">
    <mat-icon class="toggle-icon" [svgIcon]="expanded() ? 'minus' : 'add'" (click)="toggleExpanded()"></mat-icon>
  </div>
  @for (section of sections(); track section.id) {
    @let isSectionActive = activeSectionPathSegment() === section.pathSegment;
    @let showSectionSelected = isSectionActive && (
      !activeSectionItemPathSegment()
      || isSectionRecord(section)
      || !section.sectionExpanded()
      || !expanded()
    );
    <div class="side-bar-section" [class.section-active]="isSectionActive" [class.selected]="showSectionSelected">
      <div class="side-bar-section-header" (click)="sectionClicked(section)">
        <mat-icon class="section-icon" [class.section-active]="isSectionActive" svgIcon="{{ section.icon }}">
        </mat-icon>
        @if (expanded()) {
          <div class="font-label-large ms-2 me-auto" [class.font-semi-bold]="isSectionActive">
            {{ section.title }}
          </div>
          <mat-icon
            class="item-expand-icon"
            [hidden]="section.items.length === 0"
            (click)="toggleSectionExpanded(section); $event.stopPropagation()"
            [svgIcon]="section.sectionExpanded() ? 'chevron-up' : 'chevron-down'">
          </mat-icon>
        }
      </div>
      @if (section.items.length > 0 && section.sectionExpanded() && expanded()) {
        <div class="side-bar-section-items">
          @for (sectionItem of section.items; track sectionItem.id) {
            <div
              class="side-bar-section-item font-label-large"
              [class.selected]="activeSectionItemPathSegment() === sectionItem.pathSegment"
              (click)="sectionItemClicked(section, sectionItem)">
              {{ sectionItem.title }}
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="version-display font-tertiary" [class]="expanded() ? 'font-label-large' : 'collapsed-version-font'">
    {{ versionString() }}
  </div>
</div>
